import { render } from "./PrintManual.vue?vue&type=template&id=0c315511"
import script from "./PrintManual.vue?vue&type=script&lang=js"
export * from "./PrintManual.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__